import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { addCategory } from "../../redux/Slices/extSlice";
import { toast } from "react-toastify";
import {
  Paper,
  Typography,
  TextField,
  Button,
  Box,
  Input,
  Grid,
} from "@mui/material";
import { EditorState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";

const AddCategory = () => {
  const dispatch = useDispatch();
  const catRef = useRef();
  const logoRef = useRef();
  const titleRef = useRef();
  const descRef = useRef();
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const handleEditorChange = (state) => {
    setEditorState(state);
    console.log("Editor State", state);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(editorState, "editorState");
    const descriptionHtml = draftToHtml(
      convertToRaw(editorState.getCurrentContent())
    );
    console.log("Converted HTML:", descriptionHtml);
    const formData = new FormData();
    formData.append("cat_name", catRef.current.value);
    formData.append("cat_logo", logoRef.current.files[0]);
    formData.append("cat_description", descriptionHtml);
    formData.append("meta_title", titleRef.current.value);
    formData.append("meta_description", descRef.current.value);

    dispatch(addCategory(formData))
      .then((data) => {
        if (data.payload?.code === 200) {
          // console.log("if");
          // formRef.current.reset();
          catRef.current.value = "";
          logoRef.current.value = "";
          setEditorState(EditorState.createEmpty());
          titleRef.current.value = "";
          descRef.current.value = "";

          toast.success("Data loaded successfully!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        } else {
          toast.error("Something went wrong", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
      })
      .catch((err) => {
        console.log(err, "err in all ext");
        toast.error("Something went wrong", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
      });
    // console.log("Category Name:", catRef.current.value);
    // console.log("Logo File:", logoRef.current.files[0]);
  };

  return (
  <Box sx={{ pl: { xs: "10%", md: "17%" }, pt: "90px" ,pr: { xs: "10%", md: "10%" }}}>
    <Paper
      elevation={0}
      sx={{
        p: 4,
        borderRadius: 3,
        background: "#fff",
        width: "100%",
      }}
    >
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 4 }}>
        Add A Game Category
      </Typography>

      <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
        <Grid container spacing={4}>
          {/* LEFT COLUMN */}
          <Grid item xs={12} md={6}>
            <TextField
              required
              fullWidth
              label="Category Name"
              inputRef={catRef}
            />

            {/* DESCRIPTION + WYSIWYG */}
            <Box sx={{ mt: 3 }}>
              <Typography sx={{ fontSize: 14, mb: 1 }}>
                Description
              </Typography>

              <Box
                sx={{
                  border: "1px solid #ddd",
                  borderRadius: 2,
                  minHeight: 230,
                  p: 2,
                }}
              >
                <Editor
                  editorState={editorState}
                  onEditorStateChange={handleEditorChange}
                  editorClassName="demo-editor"
                  wrapperClassName="demo-wrapper"
                  placeholder="Type here..."
                />
              </Box>

              {/* Hidden HTML output */}
              <textarea
                disabled
                value={draftToHtml(
                  convertToRaw(editorState.getCurrentContent())
                )}
                style={{ width: "100%", marginTop: "18px" }}
              />
            </Box>

            <TextField
              sx={{ mt: 3 }}
              required
              fullWidth
              label="Meta Title"
              inputRef={titleRef}
            />
          </Grid>

          {/* RIGHT COLUMN */}
          <Grid item xs={12} md={6}>
            <TextField
              required
              fullWidth
              label="Meta Description"
              inputRef={descRef}
              multiline
              minRows={9}
            />

            <Box
              sx={{
                border: "1px solid #ddd",
                borderRadius: 2,
                p: 2,
                mt: 3,
              }}
            >
              <Typography sx={{ mb: 1 }}>Category Icon</Typography>
              <Button
                variant="contained"
                component="label"
                fullWidth
                sx={{
                  backgroundColor: "#6A4FE0",
                  textTransform: "none",
                  borderRadius: 2,
                  py: 1,
                  "&:hover": { backgroundColor: "#5a43c5" },
                }}
              >
                Upload Icon
                <input type="file" hidden ref={logoRef} />
              </Button>
            </Box>
          </Grid>
        </Grid>

        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{
            mt: 5,
            py: 1.5,
            backgroundColor: "#6A4FE0",
            borderRadius: 2,
            textTransform: "none",
            "&:hover": { backgroundColor: "#5a43c5" },
          }}
        >
          Add Category
        </Button>
      </Box>
    </Paper>
  </Box>


  );
};

export default AddCategory;
